import { PlanInterface } from './interfaces/plan.interface';
import { UniqueTraitsInterface } from './interfaces/uniqueTraits.interface';
export class Plan implements PlanInterface {
    id: number;
    name: string;
    code: string;
    group: number;
    price: Record<string, { [key: string]: number }> = { '1m': {}, '12m': {} };
    unique_traits: UniqueTraitsInterface = {
        nag_for_upgrade: false,
        statistics: false,
        accessibility: false,
        api_users: false,
        clarity_pdf_accessibility: false,
        clarity_pdf_remediation: false,
        closed_caption: false,
        cookie_banner: false,
        custom_crawl_callback: false,
        custom_scan_interval: false,
        dashboard_important_notifications: false,
        data_export: false,
        data_protection: false,
        domain_group_statistics: false,
        general_book_training: false,
        general_chat_support: false,
        general_shortcuts: false,
        heartbeat: true,
        heatmap_click: false,
        heatmap_movement: false,
        heatmap_scroll: false,
        heatmaps_monthly_page_sessions: 0,
        heatmaps_monthly_sessions: 0,
        heatmaps_tracked_number_of_pages: 0,
        heatmaps_traffic_percentage: 0,
        history_center_all: false,
        html_scans: false,
        image_metadata: false,
        inventory_all: false,
        max_domains: 0,
        max_scanned_pages: 0,
        mobile_guidelines: false,
        monsido_score: false,
        monsido_starter_branding: false,
        multiple_user_agreements: false,
        on_demand_scans: false,
        page_assist: false,
        page_details: false,
        page_fix: false,
        paying: false,
        performance_tracking: false,
        performance_tracking_allowed_frequencies: [],
        performance_tracking_max_page_profiles: 0,
        performance_tracking_max_pages: 0,
        performance_tracking_max_profiles: 0,
        performance_tracking_on_demand_scan: false,
        policies_all: false,
        policy_bot: false,
        prioritized_content_all: false,
        qa_links: false,
        qa_spellcheck: false,
        quick_search: false,
        readability: false,
        report_center_all: false,
        scan_interval: 0,
        script_setup_guide: false,
        send_scan_report: true,
        seo_all: false,
        single_page_scan_any_url: false,
        skip_on_hold: false,
        source_code_excludes: false,
        spell_check_engine_priority: [],
        uptime_intervals: [],
        crawl_automatically: false,
    };
    active: boolean;
    type: string;
    created_at: string;
    updated_at: string;
    constructor (plan?: PlanInterface) {
        Object.assign(this, plan);
    }
}
